jQuery(document).ready(function ($) {
    $('button[name="toggleHtml"]').on('click', function () {
        const parentDiv = $(this).parent().parent();
        const htmlDiv = parentDiv.children('.bocss-documentation__html');
        let btnLabel = this.innerText;
        let buttonlabels = parentDiv.prevObject[0].dataset;
        if (btnLabel === buttonlabels.showTitle) {
            this.innerText = buttonlabels.hideTitle;
        } else if (btnLabel === buttonlabels.hideTitle) {
            this.innerText = buttonlabels.showTitle;
        }
        htmlDiv.toggle('400');
    });

    $('button[name="toggleShortcode"]').on('click', function () {
        const parentDiv = $(this).parent().parent();
        const shortcodeDiv = parentDiv.children('.bocss-documentation__shortcode');
        let btnLabel = this.innerText;
        let buttonlabels = parentDiv.prevObject[0].dataset;
        if (btnLabel === buttonlabels.showTitle) {
            this.innerText = buttonlabels.hideTitle;
        } else if (btnLabel === buttonlabels.hideTitle) {
            this.innerText = buttonlabels.showTitle;
        }
        shortcodeDiv.toggle('400');
    });
});


